<template>
  <section>

    <certs-table :rows="rows" @request-certificados="fetchCertificados" />

    <b-loading :active="isLoading" :is-full-page="false" />

    <b-collapse :open.sync="expanded" class="mt-4">
      <template #trigger>
        <div v-if="activeEstadoLabel"
          class="box is-clickable is-flex is-justify-content-space-between is-align-items-center">
          <span class="has-text-weight-semibold">
            {{ activeOrgName }} — {{ activeEstadoLabel }}
          </span>

          <b-icon :icon="expanded ? 'chevron-down' : 'chevron-left'" size="is-small" />
        </div>
      </template>

      <div class="box">
        <certs-panel v-if="certificados.length" :certificados="certificados" />

        <div v-else class="has-text-grey">
          No hay certificados para mostrar
        </div>
      </div>
    </b-collapse>

  </section>
</template>

<script>
import CertsTable from '@/components/certificados/CertsTable.vue'
import CertsPanel from '@/components/certificados/CertsPanel.vue'

export default {
  name: 'CertsTableView',

  components: {
    CertsTable,
    CertsPanel
  },

  data () {
    return {
      rows: [],
      certificados: [],
      expanded: false,
      isLoading: false,
      activeEstado: null,
      activeOrgName: null
    }
  },

  computed: {
    activeEstadoLabel () {
      const map = {
        total: 'Total',
        prePendiente: 'Pre-Pendiente',
        pendiente: 'Pendiente',
        rechazado: 'Rechazado',
        vencido: 'Vencido',
        revocado: 'Revocado',
        preaprobado: 'Pre-Aprobado',
        vigente: 'Vigente',
        proximosAVencer: 'Próximos a Vencer'
      }
      return map[this.activeEstado]
    }
  },

  created () {
    this.fetchCertsSummary()
  },

  methods: {
    async fetchCertsSummary () {
      this.isLoading = true
      try {
        const orgId = this.$store.state.session.user.organization

        const { data } = await this.$http.get(`/test-cert/${orgId}`)

        this.rows = data
      } catch (e) {
        this.rows = []

        this.$buefy.snackbar.open({
          message: 'Error al recuperar el resumen de certificados',
          type: 'is-danger'
        })
      } finally {
        this.isLoading = false
      }
    },

    async fetchCertificados ({ orgId, estado }) {
      const row = this.rows.find(r => r.orgId === orgId)

      this.activeEstado = estado
      this.activeOrgName = row?.orgName || null
      this.expanded = true
      this.isLoading = true

      try {
        const { data } = await this.$http.get(
          `/test-cert/${orgId}/${estado}`
        )

        this.certificados = data
      } catch (e) {
        this.certificados = []

        this.$buefy.snackbar.open({
          message: 'Error al recuperar los certificados',
          type: 'is-danger'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
